import { Box, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { TaskSortDir, TaskSortField } from '../../utils/task.utils';

interface SortableColumnHeaderProps {
  label: string;
  field: TaskSortField;
  activeField: TaskSortField;
  activeDir: TaskSortDir;
  onSort: (field: TaskSortField) => void;
}

export default function SortableColumnHeader({
  label,
  field,
  activeField,
  activeDir,
  onSort,
}: SortableColumnHeaderProps) {
  const isActive = activeField === field;

  return (
    <Box
      onClick={() => onSort(field)}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        cursor: 'pointer',
        userSelect: 'none',
        color: isActive ? '#3B82F6' : 'text.secondary',
        '&:hover': { color: '#3B82F6' },
      }}
    >
      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {label}
      </Typography>
      {isActive && (
        activeDir === 'asc'
          ? <ArrowUpwardIcon sx={{ fontSize: 14 }} />
          : <ArrowDownwardIcon sx={{ fontSize: 14 }} />
      )}
    </Box>
  );
}
